import firebase from 'firebase/app';
import 'firebase/firestore';

const frb = firebase.initializeApp({
  apiKey: 'AIzaSyCrlSLdlOAc6kTkAsEd_zdBHRldrXarge4',
  authDomain: 'ucime-se.firebaseapp.com',
  databaseURL: 'https://ucime-se.firebaseio.com',
  projectId: 'ucime-se',
  storageBucket: 'ucime-se.appspot.com',
  messagingSenderId: '952382535909',
  appId: '1:952382535909:web:859b14c2c1838a1a76bc0c',
  measurementId: 'G-45E8ZS056L',
});

const db = frb.firestore();
const rtdb = frb.database();
const storage = firebase.storage().ref();
const analytics = firebase.analytics();
const auth = firebase.auth();
const { Timestamp, GeoPoint } = firebase.firestore;
export {
  Timestamp,
  GeoPoint,
  frb,
  db,
  rtdb,
  storage,
  analytics,
  auth,
};
